import { useState, useCallback } from 'react';

export function useLoading() {
    const [loadingState, setLoadingState] = useState({
        isLoading: true,
        hasError: false,
    });

    const loadPromise = useCallback(aPromise => {
        setLoadingState({ isLoading: true, hasError: false });
        return aPromise
            .then((...args) => {
                setLoadingState({ isLoading: false, hasError: false });
                return Promise.resolve(...args);
            })
            .catch((...args) => {
                setLoadingState({ isLoading: false, hasError: true });
                return Promise.reject(...args);
            });
    }, []);

    return { loadingState, setLoadingState, loadPromise };
}
